import React from "react";
import "./app.css";
import { ThreeDots } from "react-loader-spinner";

const LoadingPopup = (props) => {
  return (
    <>
      <div
        style={{ width: "100%" }}
        id={props.id}
        className="mainContainerLoadingPopup"
      >
        <div className="rowLoadingPopup">
          {props.login === 0 ? <div className="flexbox_loading"></div> : ""}
          <div className="loaderBoxLoadingPopup">
            <ThreeDots color="black" height={100} width={100} />
            <div>{props.textLoading}</div>
          </div>
          {props.login !== 1 ? (
            <span className="loadingTextLoadingPopup"></span>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default LoadingPopup;
